import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CapturumTextareaComponent } from './textarea.component';
import { CapturumSharedModule } from '@capturum/ui/api';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    CapturumTextareaComponent
  ],
  exports: [
    CapturumTextareaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    InputTextareaModule,
    CapturumSharedModule
  ]
})
export class CapturumTextareaModule {
}
